import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CrmOpportunityFieldService {

  appCore ='';

  constructor(private http: HttpClient) {
    this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
   }

  getAllAccountTypes(groupId) {
    return this.http.get<any>(`${environment.coreUrl}Type?groupId=${groupId}`)
  }

  getAllOpportunitySource(companyID: number) {
    return this.http.get<any>(environment.configUrl + 'Source?organizationId='+companyID)
  }

  getAllOppRatings(){
    return this.http.get<any>(environment.configUrl + 'Rating')
  }

  getAllRatings() {
    return this.http.get<any>(environment.configUrl + 'Rating')
  }

  getTimezone() {
    return this.http.get<any>(`${environment.timeZoneURL}TimeZone`)
  }

  getAllEmployeesCount() {
    return this.http.get<any>(this.appCore + 'EmployeeCount')
  }

  getAllRevenues() {
    return this.http.get<any>(this.appCore + 'AnnualRevenue')
  }

  getAllOwnerships() {
    return this.http.get<any>(this.appCore + 'Ownership')
  }

  getAllIndustries() {
    return this.http.get<any>(this.appCore + 'Industry')
  }

}

